import {
  ConversationStatus,
  RequirementConditionType
} from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const getConversationAutomationStatus = (
  analysisAutomationItem: AutomationFormItem
): ConversationStatus => {
  const conversationStatusCondition =
    analysisAutomationItem.requirementConditions.find(
      (condition) =>
        condition.type === RequirementConditionType.ConversationStatusCondition
    );
  return (
    conversationStatusCondition?.conversationStatus ||
    ConversationStatus.Completed
  );
};
